export class DashboardUserManagement {
    usermanagementskin () {
        return `
            <div class="container-layout full-height">
                <div class="container-column">
                    <div class="container-body">
                        <div class="container-toolbar mb-10">
                            <div class="info-bar has-icon">
                                <span class="toolbar-text">Audit Logs</span>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="has-min-width border-table">
                            <thead>
                                <tr>
                                <th>Username</th>
                                <th>IP</th>
                                <th>Timestamp</th>
                                <th>Details</th>
                                </tr>
                            </thead>
                            <tbody id="audit-body"></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}